/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ActionCondition from 'cio/app-models/conditions/action';
import Component from '@glimmer/component';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import { inject as service } from '@ember/service';
import { restartableTask } from 'ember-concurrency';
import ApiService from 'cio/services/api';
import { Entities } from 'cio/utils/metrics/common';
import { pluralize } from 'ember-inflector';
import FiltersService from 'cio/services/filters';
import { isNone } from '@ember/utils';
import { trackedTask } from 'ember-resources/util/ember-concurrency';

interface Args {
  condition: ActionCondition;
  disabled: boolean;
  size: string;
  classNames?: string[];
}

export default class TrackedResponseName extends Component<Args> {
  @service api!: ApiService;
  @service filters!: FiltersService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);

    this.fetchTrackedResponsesTask.perform();
  }

  fetchTrackedResponsesTask = restartableTask(async () => {
    if (!this.shouldFetchTrackedResponses) {
      return [];
    }

    let path = this.buildTrackedResponseRequestPath();
    if (path == null) {
      return [];
    }

    try {
      let response = await this.api.request(path, { ignoreErrors: true });
      return response.tracked_responses;
    } catch {
      return [];
    }
  });

  trackedResponses = trackedTask(this, this.fetchTrackedResponsesTask, () => [this.args.condition.action]);

  get shouldFetchTrackedResponses(): boolean {
    return this.args.condition.isAny === false;
  }

  private extractEntityMeta() {
    let { action: outputId } = this.args.condition;

    let filterMessage = this.filters.segmentable.find(
      (item) => item.type === MessagingChannelType.InApp && item.output_id === outputId,
    );

    if (isNone(filterMessage) || (isNone(filterMessage.action_id) && isNone(filterMessage.newsletter_id))) {
      return null;
    }

    let isNewsletter = filterMessage.action_id.startsWith('n');
    let entityId = isNewsletter ? filterMessage.newsletter_id : filterMessage.action_id;

    return {
      id: entityId,
      isNewsletter,
    };
  }

  private buildTrackedResponseRequestPath() {
    let entityMeta = this.extractEntityMeta();
    if (entityMeta == null) {
      return null;
    }

    let entity = entityMeta.isNewsletter ? Entities.NEWSLETTER : Entities.ACTION;
    return `${pluralize(entity)}/${entityMeta.id}/tracked_responses`;
  }
}
